import {
  ApiPortalCalculatePostRequest,
  ApiPortalForecastPostRequest,
  ApiPortalGenerateProposalPostRequest,
  ApiPortalPackagesGetRequest,
  ApiPortalSpotlengthsGetRequest,
  CalculationResult,
  ForecastTargetGroup,
  PackageOutput,
  SalesPeriodResult,
  V1Api,
} from "./api";
import { ForecastResult } from "./api/models";
import apiConfig from "./apiConfig";
import { Medium } from "./types";

export interface PackagesRequest {
  medium: Medium;
  month: number;
  year: number;
}

export const fetchPackages = async (
  request: ApiPortalPackagesGetRequest,
): Promise<PackageOutput> => {
  const portalApi = new V1Api(apiConfig());
  return Promise.resolve(portalApi.apiPortalPackagesGet(request));
};

export interface ForecastsRequest {
  medium: Medium;
}

export const fetchSpotLengths = async (
  request: ApiPortalSpotlengthsGetRequest,
): Promise<Array<number>> => {
  const portalApi = new V1Api(apiConfig());
  return Promise.resolve(portalApi.apiPortalSpotlengthsGet(request));
};

export const fetchCalculate = async (
  input: ApiPortalCalculatePostRequest,
): Promise<CalculationResult> => {
  const portalApi = new V1Api(apiConfig());
  return portalApi.apiPortalCalculatePost(input);
};

export const fetchForecasts = async (
  input: ApiPortalForecastPostRequest,
): Promise<ForecastResult> => {
  const portalApi = new V1Api(apiConfig());
  return portalApi.apiPortalForecastPost(input);
};

export const fetchProposal = async (
  input: ApiPortalGenerateProposalPostRequest,
): Promise<void> => {
  const portalApi = new V1Api(apiConfig());
  return portalApi.apiPortalGenerateProposalPost(input);
};

export const fetchForecastConversionGroups = async (
  medium: Medium,
): Promise<ForecastTargetGroup[]> => {
  const portalApi = new V1Api(apiConfig());
  return (
    await Promise.resolve(portalApi.apiPortalForecastConversionGroupsGet())
  ).conversionGroups[medium];
};

export const fetchSalesPeriod = async (): Promise<SalesPeriodResult[]> => {
  const portalApi = new V1Api(apiConfig());
  return portalApi.apiPortalSalesPeriodGet();
};
